import { combineReducers } from 'redux';
import state from './business';

export default combineReducers({ state  });